<template>
  <v-container class="tabs-content__container">
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center">
          <v-text-field
            label="Enter your id"
            v-model="link"
            outline
            single-line
            hide-details
            class="select-bordered"
          />
          <v-btn
            color="primary"
            @click="parseSpreadsheet"
          >
            Get Preview
          </v-btn>
          <v-spacer/>
          <v-btn
            v-if="previews.length"
            color="primary"
            @click="storePreviews"
          >
            <span v-if="previews.length === 1">
              Save Preview
            </span>
            <span v-else>
              Save Previews
            </span>
          </v-btn>
        </div>
      </v-col>
      <v-col
        cols="12"
        v-for="(link, index) in links"
        :key="index"
      >
        <div class="list-link d-inline-flex align-center mt-2">
          <a
            class="pa-2"
            :href="link"
            target="_blank"
          >
            {{ link }}
          </a>
          <div
            class="list-link__btn d-flex pa-3 pointer"
            v-ripple
            @click="copyToClipboard(index)"
          >
            <v-icon class="ma-auto white--text">file_copy</v-icon>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-card class="mt-3">
          <v-card-text
            class="adPreview adPreview__preview pa-0"
            v-if="previews.length"
          >
            <v-layout row wrap align-start>
              <v-card
                class="pointer d-inline ma-3 preview-iframe"
                text
                tile
                v-for="(preview, index) in previews"
                :key="index"
                >
                <div class="text-right">
                  <v-btn
                    icon
                    small
                  >
                    <v-icon small @click="$store.commit('preview/DELETE_PREVIEW', preview)">close</v-icon>
                  </v-btn>
                </div>
                <div
                  class="resp-container"
                  v-html="preview"
                />
              </v-card>
            </v-layout>
          </v-card-text>
          <v-card-text
            class="adPreview adPreview__placeholder"
            v-if="!links.length && !previews.length"
          >
            <v-row>
              <v-col cols="12" class="text-center">
                <v-icon class="display-4">mdi-camera-image</v-icon>
                <div class="display-1">You haven't added anything yet</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AddPreviewIndex',
    data: () => {
      return {
        link: ''
      }
    },
    computed: {
      previews () {
        return this.$store.getters.previews
      },
      links () {
        return this.$store.getters.links
      }
    },
    methods: {
      parseSpreadsheet () {
        const id = this.getSpreadsheetId()
        if (!id) {
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: ['Your link is not valid.']
          })
          return false
        }
        this.$store.dispatch('parseSpreadsheet', id)
      },
      getSpreadsheetId () {
        const linkToArray = this.link.split('/')
        const dIndex = linkToArray.findIndex(item => item === 'd')
        const editIndex = linkToArray.findIndex(item => item.indexOf('edit') !== -1)
        if (dIndex > -1 && editIndex > -1) {
          return linkToArray[dIndex + 1]
        }
        return false
      },
      storePreviews () {
        return new Promise(resolve => {
          resolve(this.$store.dispatch('storePreviews'))
        })
          .then(ids => console.log(ids))
      },
      copyToClipboard (index) {
        const el = document.createElement('textarea')
        el.value = this.links[index]
        el.setAttribute('readonly', '')
        el.style = {position: 'absolute', left: '-9999px'}
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        this.$store.dispatch('showNotification', {
          type: 'success',
          message: ['You copied the link']
        })
      }
    }
  }
</script>
<style>
  .preview-iframe {
    width: 546px;
    height: auto!important;
    overflow: hidden;
  }
  .resp-container {
    position: relative;
    padding-top: 100%;
    width: 100%;
    height: 100%;
  }
  .resp-container iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
  .list-link {
    background: #EEEEEE;
    width: 100%;
    max-width: 430px;
  }
  .list-link__btn{
    background: #3172d0;
    max-width: 60px;
  }
</style>
